import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import ContentHeader from 'component/utils/ContentHeader'
import Grid from 'component/utils/Grid'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Pagination from 'component/pagination/Pagination'
import Notification from 'component/utils/Notification'
import Table from './Table'
import * as justificationsActions from 'action/justifications'
import Modal from 'component/Modal/GenericModal'
import Button from 'component/Button'
import Select from 'component/Select/Select'
import TextField from 'component/TextField'
import Plus from '../../../images/icon-plus.svg'

import CloseIconSVG from 'component/svgComponents/close'
import FilterIconSVG from 'component/svgComponents/filter'
import SuccessModal from 'component/Modal/SuccessModal'

class Justifications extends Component {
  constructor(props) {
    super(props)

    this.state = {
      editModalOpen: false,
      newJustifications: [null],
      editMode: false,
      editJustificationData: {},
      filterValue: null,
      successMsg: null,
    }
  }

  static propTypes = {
    auth: PropTypes.object.isRequired,
    count: PropTypes.number.isRequired,
    current: PropTypes.number.isRequired,
    pages: PropTypes.number.isRequired,
    fetchJustificationsList: PropTypes.func.isRequired,
    updateJustification: PropTypes.func.isRequired,
    removeJustification: PropTypes.func.isRequired,
    justifications: PropTypes.array.isRequired,
    translate: PropTypes.func.isRequired,
    error: PropTypes.object,
  }

  componentDidMount() {
    this.handleFetchJustifications()
  }

  handleFetchJustifications = (page) => {
    const {
      auth: { user },
      fetchJustificationsList,
    } = this.props
    const { filterValue } = this.state

    this.setState({ sideFilterVisible: false })

    fetchJustificationsList(
      user.dsToken,
      page,
      typeof filterValue === 'number' ? { inInactive: filterValue } : {}
    )
  }

  updateJustificationIsActive = (justification) => {
    const {
      auth: { user },
      updateJustification,
    } = this.props

    updateJustification(user.dsToken, justification, true).then(() => {
      this.handleFetchJustifications()
    })
  }

  saveJustification = (values, update) => {
    const {
      auth: { user },
      updateJustification,
    } = this.props

    updateJustification(user.dsToken, values, update).then(
      () => {
        this.handleFetchJustifications()
        this.clearForm()
        this.setState({
          successMsg: 'justification.add.success',
        })
      },
      () => {
        this.clearForm()
      }
    )
  }

  handleRemoveJustification = (idJustification) => {
    const {
      auth: { user },
      removeJustification,
    } = this.props

    removeJustification(user.dsToken, { idJustification }).then(() => {
      this.handleFetchJustifications()
      this.setState({
        successMsg: 'justification.exclude.success',
      })
    })
  }

  renderPagination = () => {
    const { pages } = this.props

    if (!pages || pages < 2) {
      return null
    }

    const { current, count } = this.props

    return (
      <Col className='align-center margin-top'>
        <Pagination
          getPage={this.handleFetchJustifications}
          pages={pages}
          current={current}
          count={count}
        />
      </Col>
    )
  }

  renderNotification() {
    const { error } = this.props

    return (
      error && (
        <Row>
          <Col
            lg={6}
            lgOffset={3}
            md={6}
            mdOffset={3}
            sm={12}
            xs={12}
            className='margin-top'
          >
            <Notification
              className='notification-warning margin-bottom'
              message={error.message.dsMessage}
            />
          </Col>
        </Row>
      )
    )
  }

  handleOpenEditModal = (justification) => {
    this.setState({
      editModalOpen: true,
      newJustifications: [justification.dsJustification],
      editMode: true,
      editJustificationData: justification,
    })
  }

  clearForm = () => {
    this.setState({
      editModalOpen: false,
      newJustifications: [null],
      editMode: false,
    })
  }

  handleEditJustification = () => {
    const { newJustifications, editJustificationData } = this.state

    this.saveJustification(
      { ...editJustificationData, dsJustification: newJustifications[0] },
      true
    )
  }

  handleSaveJustification = () => {
    const { newJustifications } = this.state
    this.saveJustification(
      newJustifications
        .filter((j) => j)
        .map((j) => ({ dsJustification: j, inInactive: 0, inNotCounted: 0 }))
    )
  }

  render() {
    const {
      editModalOpen,
      newJustifications,
      editMode,
      sideFilterVisible,
      filterValue,
      successMsg,
      editJustificationData,
    } = this.state
    const { translate, justifications } = this.props

    const filterStatusOptions = [
      { value: null, label: translate('option.all') },
      { value: 0, label: translate('justificationsPa.active') },
      { value: 1, label: translate('justificationsPa.inactive') },
    ]

    return (
      <div>
        {successMsg && (
          <SuccessModal
            t={translate}
            handleClose={() => this.setState({ successMsg: null })}
            size='md'
            msg={translate(successMsg)}
          />
        )}
        {sideFilterVisible && (
          <>
            <div className='bg-filter' />
            <div className='right-filter-container'>
              <CloseIconSVG className="right-filter-svg"
                onClick={() => this.setState({ sideFilterVisible: false })}
              />
              <h3 className='margin-bottom-triple'>
                <strong>{translate('delimit.report.filter')}</strong>
              </h3>
              <Row className='w-100'>
                <Col>
                  <Select
                    fill
                    required
                    value={
                      typeof filterValue === 'number'
                        ? filterStatusOptions.find(
                            (opt) => opt.value === filterValue
                          )
                        : filterStatusOptions[0]
                    }
                    label={translate('Status')}
                    options={filterStatusOptions}
                    onChange={({ value }) =>
                      this.setState({
                        filterValue: value,
                      })
                    }
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} className='margin-bottom margin-top no-padding'>
                  <Button
                    className='btn btn-primary full-w'
                    onClick={this.handleFetchJustifications}
                    text={translate('filter_button_label')}
                  />
                </Col>
              </Row>
            </div>
          </>
        )}
        <ContentHeader>{translate('justification.irc.title')}</ContentHeader>

        <div className='float-right margin-top margin-right'>
          <Modal
            isConfirmButtonDisabled={
              editMode
                ? newJustifications[0] === editJustificationData.dsJustification
                : !newJustifications.some((j) => j)
            }
            title={
              editMode
                ? translate('justifications.justificationEdit')
                : translate('justifications.justificationNew')
            }
            confirmButtonText={translate('justificationsPa.register')}
            cancelButtonText={translate('query.logs.modal.close')}
            onConfirm={
              editMode
                ? this.handleEditJustification
                : this.handleSaveJustification
            }
            isOpen={editModalOpen}
            useControlledState
            onCloseModal={this.clearForm}
            renderButton={() => (
              <Button
                className='btn btn-primary margin-right'
                text={translate('justificationsPa.new.button')}
                onClick={() => this.setState({ editModalOpen: true })}
              />
            )}
          >
            {newJustifications.map((just, idx) => (
              <Row key={idx} className='w-100'>
                <Col xs={12}>
                  <TextField
                    label={translate(
                      just
                        ? 'missionMenu.addModal.field.dsJustification.placeholder'
                        : 'missionMenu.addModal.field.dsJustification.hint'
                    )}
                    placeholder={translate(
                      'missionMenu.addModal.field.dsJustification.placeholder'
                    )}
                    fill
                    required
                    value={just}
                    onChange={(e) => {
                      newJustifications[idx] = e.target.value
                      this.setState({ newJustifications })
                    }}
                  />
                </Col>
              </Row>
            ))}
            {!editMode && (
              <span
                className={
                  newJustifications[newJustifications.length - 1]
                    ? 'add-field'
                    : 'add-field add-field-disabled'
                }
                onClick={() => {
                  if (newJustifications[newJustifications.length - 1]) {
                    newJustifications.push(null)
                    this.setState({ newJustifications })
                  }
                }}
              >
                <img src={Plus} alt='' />
                {translate('missionMenu.addModal.field.dsJustification.add')}
              </span>
            )}
          </Modal>
          <Button
            className='btn btn-secondary'
            text={'Filtro'}
            onClick={() => this.setState({ sideFilterVisible: true })}
            svgIcon
            svgComponent={<FilterIconSVG className="margin-default-svg" newDesign={false} />}

          />
        </div>

        {this.renderNotification()}

        <Grid fluid>
          <Col
            lg={12}
            md={12}
            sm={12}
            xs={12}
            className='align-center margin-top'
          >
            <Table
              justifications={justifications}
              translate={translate}
              updateActive={this.updateJustificationIsActive}
              remove={this.handleRemoveJustification}
              editEntry={this.handleOpenEditModal}
            />
          </Col>
          {this.renderPagination()}
        </Grid>
      </div>
    )
  }
}

/* istanbul ignore next */
const mapStateToProps = ({ justificationReducer, paginateReducer }) => ({
  justifications: justificationReducer.list.records,
  error: justificationReducer.edit.error,
  pages: paginateReducer.pages,
  count: paginateReducer.count,
  current: paginateReducer.current,
})

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(justificationsActions, dispatch)

const HomeTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(Justifications)

export default connect(mapStateToProps, mapDispatchToProps)(HomeTranslated)

export { Justifications }
